import request from '@/utils/request'

// 取得订单成功率
export function getOrderProbability(params) {
  return request({
    url: '/statistics/orderProbability',
    method: 'get',
    params: params,
  })
}

// 取得二维码订单成功率
export function getCodeOrderProbability(params) {
  return request({
    url: '/statistics/qrCode/orderProbability',
    method: 'get',
    params: params,
  })
}

// 取得资料汇总今日、昨日，支付、提现
export function getTradeSummary(params) {
  return request({
    url: '/statistics/tradeSummary',
    method: 'get',
    params: params,
  })
}

// 取得二维码资料汇总今日、昨日，支付、提现
export function getCodeTradeSummary(params) {
  return request({
    url: '/statistics/qrCode/tradeSummary',
    method: 'get',
    params: params,
  })
}


// 代理统计 2022 03 07 影响效能暂时不使用
export function getStatisticsAgentCount(params) {
  return request({
    url: '/service/v1/ums/angent/count',
    method: 'get',
    params: params,
  })
}

// 代理统计 subList
export function getStatisticsAgentSubList(params) {
  return request({
    url: '/service/v1/ums/angent/count/subList',
    method: 'get',
    params: params,
  })
}

// 獲得客戶統計根據當前登錄代理
export function getCustomerStatisticsByAgent(params) {
  return request({
    url: '/service/v1/ums/customer/count/getListByAgent',
    method: 'get',
    params: params,
  })
}

export function getStatisticsSeller(params) {
  return request({
    url: '/service/v1/mms/merchant/count',
    method: 'get',
    params: params,
  })
}

// 统计时间内，按照天汇总商户每个项目数据
export function getStatisticsSellerList(params) {
  return request({
    url: '/service/v1/mms/merchant/countAppByDay',
    method: 'get',
    params: params,
  })
}

// 按照天统计银行
export function getStatisticsBankCard(params) {
  return request({
    url: '/service/v1/ums/bank/countByDayHour',
    method: 'get',
    params: params,
  })
}

// 二维码按照天统计银行
export function getCodeStatisticsBankCard(params) {
  return request({
    url: '/service/v1/ums/qrCode/countByDayHour',
    method: 'get',
    params: params,
  })
}

// Excel Sheet
export function getDailyDLStatistic(params) {
  return request({
    url: '/statistics/dailyDLStatistic',
    method: 'get',
    params: params,
  })
}

// 获取客服接单绩效列表
export function getOrderStatistics(params) {
  return request({
    url: '/user/kefu/statistics/getOrderStatistics',
    method: 'get',
    params,
  })
}

// 客服统计数据指定日期重作
export function refreshKefuOrderStatistics(data) {
  return request({
    url: '/user/kefu/statistics/refreshKefuOrderStatistics',
    method: 'post',
    data: data,
  })
}

// 获取客服日统计报表
export function getDailyStatisticsByKefu(params) {
  return request({
    url: '/user/kefu/statistics/getDailyStatistics',
    method: 'get',
    params,
  })
}

// 获取卡主日统计报表
export function getDailyStatisticsByCustomer(params) {
  return request({
    url: '/service/v1/ums/customer/count/getDailyStatistics',
    method: 'get',
    params,
  })
}

// 获取审核员日统计报表
export function getDailyStatisticsByAuditor(params) {
  return request({
    url: '/service/v1/ums/Auditor/getDailyStatistics',
    method: 'get',
    params,
  })
}


// WEBPACK FOOTER //
// ./src/api/statistics.js